import { Controller } from "@hotwired/stimulus"

// Reorders in-line-form field rows (move up / move down) and keeps each row's hidden `position` input in
// sync with its visual order, so the server persists the ordering. Destroyed rows (hidden) are skipped.
export default class extends Controller {
  connect() {
    this.renumber()
  }

  moveUp(event) {
    const row = this.rowFor(event)
    const prev = this.previousVisible(row)
    if (prev) {
      row.parentNode.insertBefore(row, prev)
      this.renumber()
    }
  }

  moveDown(event) {
    const row = this.rowFor(event)
    const next = this.nextVisible(row)
    if (next) {
      row.parentNode.insertBefore(next, row)
      this.renumber()
    }
  }

  // Stamp each visible row's position input with its index (called on connect, move, and add).
  renumber() {
    this.visibleRows().forEach((row, index) => {
      const input = row.querySelector('[data-field-reorder-target="position"]')
      if (input) input.value = index
    })
  }

  rowFor(event) {
    return event.target.closest('.nested-form-wrapper')
  }

  visibleRows() {
    return Array.from(this.element.querySelectorAll('.nested-form-wrapper')).filter(
      row => !row.classList.contains('hidden') && row.style.display !== 'none'
    )
  }

  previousVisible(row) {
    const rows = this.visibleRows()
    return rows[rows.indexOf(row) - 1] || null
  }

  nextVisible(row) {
    const rows = this.visibleRows()
    return rows[rows.indexOf(row) + 1] || null
  }
}
